import { render, staticRenderFns } from "./FormPhoneArea.vue?vue&type=template&id=2f25a98d&scoped=true&"
import script from "./FormPhoneArea.vue?vue&type=script&lang=js&"
export * from "./FormPhoneArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f25a98d",
  null
  
)

export default component.exports